import React from 'react';
import styled from 'styled-components/macro';
import { Col } from 'antd';
import { Colors, Drawer, Body as Label, Title } from '@cognite/cogs.js';

type DrawerWithTitleProps = {
  children: React.ReactNode;
  footer: React.ReactNode;
  onCancel: VoidFunction;
  selectedMilestoneName?: string;
  subHeader?: React.ReactNode;
  title: React.ReactNode;
  visible: boolean;
};

export const DrawerWithTitle = ({
  children,
  footer,
  onCancel,
  selectedMilestoneName,
  subHeader,
  title,
  visible,
}: DrawerWithTitleProps) => {
  const renderTitleMilestoneTag = () =>
    selectedMilestoneName && (
      <StyledMilestoneLabel>{selectedMilestoneName}</StyledMilestoneLabel>
    );

  const renderTitle = () => (
    <StyledDrawerHeader>
      <StyledDrawerHeaderContent>
        <div>
          <StyledDrawerHeaderTitle>{title}</StyledDrawerHeaderTitle>
          {renderTitleMilestoneTag()}
        </div>
        {subHeader}
      </StyledDrawerHeaderContent>
    </StyledDrawerHeader>
  );

  return (
    <StyledDrawer
      width="90%"
      visible={visible}
      onCancel={onCancel}
      footer={footer}
      title={undefined}
    >
      <>
        {renderTitle()}
        <StyledCol>{children}</StyledCol>
      </>
    </StyledDrawer>
  );
};

const StyledDrawer = styled(Drawer)`
  overflow: hidden;
  .cogs-drawer-header {
    width: 16px;
    height: 32px;
    position: absolute;
    right: 16px;
    top: 16px;
    display: flex;
    align-items: center;
  }
  .drawer-content-wrapper {
    max-width: 886px;
    overflow: hidden;
  }
  .cogs-drawer-content {
    padding: 0;
  }
  .cogs-drawer-close {
    cursor: pointer;
    border-bottom: 0;
  }
`;

const StyledCol = styled(Col)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 3rem;
`;

const StyledDrawerHeader = styled.div`
  border-bottom: 1px solid var(--cogs-border-default);
`;
const StyledDrawerHeaderContent = styled.div`
  padding: 1rem 2rem 1rem 3rem;
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  > div {
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    gap: 1rem;
    display: flex;
  }
`;
const StyledDrawerHeaderTitle = styled(Title)`
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
`;

const StyledLabel = styled(Label)`
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
  }
`;

const StyledMilestoneLabel = styled(StyledLabel)`
  background: var(--cogs-bg-status-small--accent);
  color: var(--cogs-white);
  border-radius: 4px;
`;
